import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { Chart } from 'highcharts';
import { toRef } from 'vue';
import { RotateCcw } from 'lucide-vue-next';
import GenericChart from '@/components/charts/GenericChart.vue';
import { Button } from '@/components/ui/button';
import type { GroupedWeeklySeries } from '@/composables/records/useGroupedWeeklyAggregation';
import { useGroupedWeeklyChartOptions } from '@/composables/records/useGroupedWeeklyChartOptions';
import { clearHoverBand } from '@/composables/records/useRecordsChartOptions';

/*
 * The multi-series counterpart of `RecordsWeeklyChart`: one bar per series per week, grouped side
 * by side, where that component draws exactly one series. Click-to-select-a-week, fade-on-selection
 * and the hover band behave the same on both, and both resolve them in their options composable.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'GroupedWeeklyChart',
  props: {
    series: {},
    selectedWeekStart: {},
    colors: {},
    title: {},
    seriesIdPrefix: {},
    pointDetail: { type: Function }
  },
  emits: ["week-selected", "selection-reset"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const options = useGroupedWeeklyChartOptions(toRef(props, 'series'), toRef(props, 'selectedWeekStart'), {
    colors: props.colors,
    title: toRef(props, 'title'),
    seriesIdPrefix: props.seriesIdPrefix,
    pointDetail: (weekStart: string, seriesId: number) => props.pointDetail?.(weekStart, seriesId) ?? null,
    onBinClicked: (weekStart: string) => emit('week-selected', weekStart),
});

function onChartUpdate(instance: Chart) {
    // A redraw drops imperatively added bands; the next pointer move puts a fresh one back.
    clearHoverBand(instance);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GenericChart, {
    options: (_unref(options) as any),
    onUpdate: onChartUpdate
  }, {
    "prepend-actions": _withCtx(() => [
      _renderSlot(_ctx.$slots, "prepend-actions"),
      _createVNode(_unref(Button), {
        variant: "outline",
        size: "sm",
        disabled: _ctx.selectedWeekStart === null,
        "aria-label": _ctx.$t('views.pigs.records.chart.resetSelectionHint'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('selection-reset')))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(RotateCcw), {
            class: "size-4 mr-1.5",
            "aria-hidden": "true"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('views.pigs.records.chart.resetSelection')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "aria-label"])
    ]),
    _: 3
  }, 8, ["options"]))
}
}

})